var DropDown        = require("./DropDown");
var $               = require("jquery");
var _ 				= require("underscore");


var MODE = {
	/* выключено - кнопка с линейкой, не подсвечена */
	OFF: 'off',
	/* рисование - кнопка с иконкой типа геометрии, подсвечена */
	DRAW: 'draw',
	/* ожидание (по концепту. По сути это редактор геометрии)
	 - кнопка с линейкой, подсвечена */
	IDLE: 'idle'
};

var defaultOptions = {
	activeClass: 'active',
	idleClass: 'idle',

	icon: false,
	iconActive: false
};

var MeasureToolChanger = DropDown.extend({
	initialize: function(options){
		var that = this;
		options = options || {};
		options = $.extend({}, defaultOptions, options);
		MeasureToolChanger.__super__.initialize.call(that, options);

		that.MODE = MODE.OFF;
		that.selectedWidget_ = false;

		var $container = that.getContainer();
		$container.addClass('omjs-measure-changer');

		/* Отписываем кнопку от предыдущих обработчиков 
		клика чтобы не было конфликтов */
		that.$actionButton.off('focus');
		that.$actionButton.on('click', that._onActionClick.bind(that));
	},

	onAdd: function(view){
		var that = this;
		MeasureToolChanger.__super__.onAdd.call(that, view);
		that.measurement = that.view.getMeasurement();

		that.measurement.on('drawstart', 	that._onDrawStart,		that);
		that.measurement.on('drawend', 		that._onDrawEnd,		that);
		that.measurement.on('modifystart', 	that._onModifyStart,	that);
		that.measurement.on('modifyend', 	that._onModifyEnd,		that);
	},

	_onDrawStart:function(){},
	_onDrawEnd:function(event){
		var that = this;
		that.setMode(MODE.IDLE);
		that.$actionButton.addClass(that.options.idleClass);
		that.setActionIcon(that.options.iconActive);
		that.resetActiveForItems();
		that.measurement.activateModifyInteraction(event.feature);
	},

	_onModifyStart:function(){},
	_onModifyEnd:function(){},

	__onItemClick__: function(widget, $event){
		var that = this;
		if (that.selectedWidget_ == widget && that.getMode() == MODE.DRAW) {
			that.selectedWidget_ = false;
			that.setMode(MODE.IDLE);
			that.resetActiveForItems();
			that.setActionIcon(that.options.iconActive);
			that.measurement.stopDrawInteraction();
		} else {
			that.selectedWidget_ = widget;
			that.setMode(MODE.DRAW);
			that.resetActiveForItems(true);
			that.setActiveForItem(widget);
			that.setActionIcon(widget.getActiveIcon());
			that.$actionButton.addClass(that.options.idleClass);
			that.measurement.deactivateModifyInteraction(true);
		}
		MeasureToolChanger.__super__.__onItemClick__.call(this, widget, $event);
	},

	_onActionClick: function(){
		var that = this;

		if (that.isTouch) {
			if (!that._opened) {
				that.showContainer();
			} else {
				that._turnOff();
			}
		} else {
			that._turnOff();
		}
	},

	resetActiveForItems: function(opt_resetActionIcon){
		var options = this.options;
		_.each(this.options.elements, function(omjsWidget){
			omjsWidget.getContainer().removeClass(options.activeClass);
			omjsWidget.unsetActiveIcon();
		});
		if (opt_resetActionIcon) {
			this.setActionIcon(null);
		}
	},

	setActiveForItem: function(omjsWidget){
		var options = this.options;
		var widget = _.filter(this.options.elements, function(_widget){
			return _widget == omjsWidget;
		})[0];
		widget.getContainer().addClass(options.activeClass);
		widget.setActiveIcon();
		if (widget.getIcon) {
			this.setActionIcon(widget.getIcon());
		} else {
			this.setActionIcon(null);
		}
	},

	_turnOff: function(){
		var that = this;
		if (that.getMode() !== MODE.OFF) {
			that.measurement.stopInteraction();
			that.selectedWidget_ = false;
			that.resetActiveForItems(true);
			that.$actionButton.removeClass(that.options.idleClass);
			that.setActionIcon(null);
			that.setMode(MODE.OFF);
		}
	},

	setMode: function(mode){
		var that = this;
		var available_modes = _.values(MODE);
		if (_.contains(available_modes, mode)) {
			that.MODE = mode;
		} else {
			console.warn('Неизвестный режим ['
				+ mode + ']. Режим должен быть одним из ['
				+ available_modes.join(',') + ']');
		}
	},

	getMode: function(){
		return this.MODE;
	}

});

module.exports = MeasureToolChanger;


//////////////////
// WEBPACK FOOTER
// ./src/View/Widget/MeasureToolChanger.js
// module id = 227
// module chunks = 0